<template>
    <el-form :model="goodsForm" inline="inline" label-position="left" label-width="200px" ref="goodsForm">
        <div class="invoice_table goods_list" v-if="invoiceItem.length > 0">
            <template v-for="(item, index) in invoiceItem">
                <el-form-item :key="index" :label="item.Title" :prop="item.FiledKey" v-if="item.FiledKey !== 'Id'">
                    <template v-if="item.DataType === '2'">
                        <el-input-number
                                :controls="false" :min="1" :readonly="isReadonly"
                                :step-strictly="true"
                                placeholder=" "
                                v-model="goodsForm[item.FiledKey]"></el-input-number>
                    </template>
                    <template v-else-if="item.DataType === '3'">
                        <el-input-number
                                :controls="false" :precision="2"
                                :readonly="isReadonly"
                                placeholder=" "
                                v-model="goodsForm[item.FiledKey]"></el-input-number>
                    </template>
                    <template v-else-if="item.DataType === '4'">
                        <el-input-number
                                :controls="false" :min="0" :precision="8"
                                :readonly="isReadonly"
                                placeholder=" "
                                v-model="goodsForm[item.FiledKey]"></el-input-number>
                    </template>
                    <template v-else-if="item.DataType === '5'">
                        <el-date-picker
                                :clearable="false"
                                :readonly="isReadonly"
                                placeholder=" "
                                type="date"
                                v-model="goodsForm[item.FiledKey]"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </template>
                    <template v-else-if="item.DataType === '6'">
                        <el-time-picker
                                :clearable="false"
                                :readonly="isReadonly"
                                format="HH:mm"
                                placeholder=" "
                                v-model="goodsForm[item.FiledKey]"
                                value-format="HH:mm">
                        </el-time-picker>
                    </template>
                    <template v-else-if="item.DataType === '7'">
                        <el-date-picker
                                :clearable="false"
                                :readonly="isReadonly"
                                format="yyyy-MM-dd HH:mm"
                                placeholder=" "
                                type="datetime"
                                v-model="goodsForm[item.FiledKey]"
                                value-format="yyyy-MM-dd HH:mm">
                        </el-date-picker>
                    </template>
                    <template v-else>
                        <el-input
                                :readonly="isReadonly"
                                placeholder=" "
                                v-model="goodsForm[item.FiledKey]"></el-input>
                    </template>
                </el-form-item>
            </template>
        </div>
    </el-form>
</template>

<script>
    export default {
        name: "goodsEdit",
        props: ['invoiceItemForm', 'isReset', 'isSubmit'],
        data() {
            return {
                goodsForm: {},
                invoiceItem: [],
                isReadonly: false
            }
        },
        created() {
            this.initForm();
            if (this.$route.name === 'myInvoiceDetail') {
                if (this.$route.query.IsEdit) {
                    this.isReadonly = true;
                } else {
                    this.isReadonly = false;
                }
            } else {
                this.isReadonly = true;
            }
        },
        computed: {
            toReset() {
                return this.isReset;
            },
            toSubmit() {
                return this.isSubmit;
            }
        },
        watch: {
            toReset(val) {
                if (val) {
                    this.initForm();
                }
            },
            toSubmit(val) {
                if (val) {
                    this.sendData();
                }
            }
        },
        methods: {
            // 赋值
            initForm() {
                this.goodsForm = {};
                this.invoiceItem = [];
                if (this.invoiceItemForm) {
                    for (let key in this.invoiceItemForm) {
                        this.invoiceItem.push(this.invoiceItemForm[key]);
                        this.$set(this.goodsForm, this.invoiceItemForm[key].FiledKey, this.invoiceItemForm[key].Value);
                    }
                }
            },
            // 向父级传值
            sendData() {
                let itemData = {};
                for (let key in this.goodsForm) {
                    let val = this.goodsForm[key];
                    itemData[key] = {
                        DataType: this.invoiceItemForm[key].DataType,
                        FiledKey: key,
                        Title: this.invoiceItemForm[key].Title,
                        Value: val
                    }
                }
                this.$emit('getItemData', JSON.stringify(this.goodsForm));
            }
        }
    }
</script>

<style scoped>

</style>
